module.exports = __webpack_public_path__ + "static/os-101-3-800x640-e3dacd176c7acbb038f64b106bf8f0ab.jpg";